export default "__VITE_ASSET__D3kYB_1m__"